import Plotly from 'plotly.js';

/**
 * Plotly.Plots.resize rejects when the graph div is not on-screen / has no layout (hidden panel, 0×0, purged).
 * Use this instead of calling resize directly so window/ResizeObserver handlers do not surface unhandled rejections.
 * @param {HTMLElement | null | undefined} gd
 */
export function plotlyResizeIfDisplayed(gd) {
  if (!gd || typeof gd.isConnected !== 'boolean' || !gd.isConnected) return;
  if (!gd._fullLayout) return;
  try {
    const st = window.getComputedStyle(gd);
    if (st.display === 'none' || st.visibility === 'hidden') return;
  } catch {
    return;
  }
  const r = gd.getBoundingClientRect();
  if (r.width < 2 || r.height < 2) return;

  let out;
  try {
    out = Plotly.Plots.resize(gd);
  } catch {
    return;
  }
  if (out && typeof out.catch === 'function') out.catch(() => {});
}
